import React, { useEffect, useState, useContext } from "react";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Input from "@mui/material/Input";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import axios from "axios";
import AuthContext from "../context/userAuth.context";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import WhatsNewAdmin from "./WhatsNewAdmin";
import AIAccessAdmin from "./AIAccessAdmin";

function AdminProps(props) {
  const [SelectedFiles, setSelectedFiles] = useState(null);
  const [propsAdminArea, setPropsAdminArea] = useState(false);
  const [objectAdminArea, setObjectAdminArea] = useState(false);
  const [categoryName, setCategoryName] = useState(null);
  const [propsCateogryList, setPropsCateogryList] = useState([]);
  const [showAlert, setShowAlert] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(1);
  const [objectCateogryList, setObjectCateogryList] = useState([]);
  const [whatsNewOpen, setWhatsNewOpen] = useState(false);
  const [aiAccessOpen, setAIAccessOpen] = useState(false);

  useEffect(() => {
    setPropsAdminArea(false);
    getPropsCategoryList();
    getObjectCategorylist();
  }, []);

  useEffect(() => {
    //console.log(propsCateogryList);
  }, [propsCateogryList]);

  const {
    authenticationData,
    setAuthenticationData,
    apiBaseurl,
    ExpiryCountdown,
    setExpiryCountdown,
    setUserData,
    setAllProject,
    Role,
  } = useContext(AuthContext);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    height: 600,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  function getPropsCategoryList() {
    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Administration/getPropsCategorylist"
      )
      .then((response) => {
        setPropsCateogryList([...response.data.response]);
        //console.log(propsCateogryList);
      });
  }

  function getObjectCategorylist() {
    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Administration/getObjectCategorylist"
      )
      .then((response) => {
        setObjectCateogryList([...response.data.response]);
        //console.log(propsCateogryList);
      });
  }

  const UploadPropsCategoryFiles = () => {
    if (SelectedFiles == null) {
      setAlertMessage("Please Select a JSON File to Upload.");
      setShowAlert("error");
      return;
    }
    //setShowAlert("");
    let formdata = new FormData();
    for (let i = 0; i < SelectedFiles.length; i++) {
      formdata.append("selectedFiles", SelectedFiles[i]);
    }
    formdata.append("categoryId", selectedCategory);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Administration/UploadPropsCategoryFiles",
        formdata
      )
      .then((response) => {
        if (response.data.message === "success") {
          setAlertMessage("Files Uploaded Sucessfully.");
          setShowAlert("success");
        } else {
          setAlertMessage("An Error Occured while uploading files.");
          setShowAlert("error");
        }
      });
  };

  const UploadObjectCategoryFiles = () => {
    if (SelectedFiles == null) {
      setAlertMessage("Please Select a SVG File to Upload.");
      setShowAlert("error");
      return;
    }
    setShowAlert("");
    let formdata = new FormData();
    for (let i = 0; i < SelectedFiles.length; i++) {
      formdata.append("selectedFiles", SelectedFiles[i]);
    }
    formdata.append("categoryId", selectedCategory);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Administration/UploadObjectCategoryFiles",
        formdata
      )
      .then((response) => {
        if (response.data.message === "success") {
          setAlertMessage("Files Uploaded Sucessfully.");
          setShowAlert("success");
        } else {
          setAlertMessage("An Error Occured while uploading files.");
          setShowAlert("error");
        }
      });
  };

  const OnChangeSelectedFiles = (event) => {
    setSelectedFiles(event.target.files);
  };

  const openPropsAdminArea = () => {
    setObjectAdminArea(false);
    setPropsAdminArea(true);
  };

  const closePropsAdmin = () => {
    props.setAdminPanelPopup(false);
  };

  const savePropsCateogry = (Event) => {
    if (categoryName === null) {
      setAlertMessage("Please Enter Valid Category Name.");
      setShowAlert("error");
      return;
    }

    let formdata = new FormData();
    formdata.append("categoryName", categoryName.trim());
    let apiPath = null;
    if (objectAdminArea == true) {
      for (var i = 0; i < objectCateogryList.length; i++) {
        if (
          categoryName.trim().toLowerCase() ===
          objectCateogryList[i].text.trim().toLowerCase()
        ) {
          setShowAlert("error2");
          return;
        }
      }
      setShowAlert("");
      apiPath = "/api/Administration/SaveObjectCategory";
    } else if (propsAdminArea == true) {
      for (var i = 0; i < propsCateogryList.length; i++) {
        if (
          categoryName.trim().toLowerCase() ===
          propsCateogryList[i].text.trim().toLowerCase()
        ) {
          setShowAlert("error2");
          return;
        }
      }
      setShowAlert("");
      apiPath = "/api/Administration/SavePropsCategory";
    }
    axios
      .post(authenticationData.ApiBaseURL + apiPath, formdata)
      .then((response) => {
        if (response.data.message === "success") {
          getPropsCategoryList();
          getObjectCategorylist();
          setAlertMessage("Category Saved Successfully.");
          setShowAlert("success");
        } else {
          setAlertMessage(
            "Error Occured while saving Category. Please check with support"
          );
          setShowAlert("error");
        }
      });
  };

  const openObjectAdminArea = () => {
    setPropsAdminArea(false);
    setObjectAdminArea(true);
  };

  return (
    <div style={{ borderRadius: 25 }}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.AdminPanelPopup}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.AdminPanelPopup}>
          <Box sx={style}>
            <Button
              size="small"
              color="error"
              onClick={closePropsAdmin}
              style={{ float: "right", marginRight: 5 }}
            >
              <CloseIcon />
            </Button>
            <Paper
              style={{
                height: 500,
                borderRadius: 5,
                backgroundColor: "transparent",
              }}
            >
              {showAlert == "error" && (
                <Alert severity="error">{alertMessage}</Alert>
              )}
              {showAlert == "error2" && (
                <Alert severity="error">Category Name Already Exists.</Alert>
              )}
              {showAlert == "success" && (
                <Alert severity="success">{alertMessage}</Alert>
              )}

              {showAlert == "info" && (
                <Alert severity="info">
                  This is an error alert — check it out!
                </Alert>
              )}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <h1>Assets Manager</h1>
                <div style={{ display: "flex", gap: 8 }}>
                  <Button variant="outlined" onClick={() => setAIAccessOpen(true)}>
                    AI Studio access
                  </Button>
                  <Button variant="outlined" onClick={() => setWhatsNewOpen(true)}>
                    What's new posts
                  </Button>
                </div>
              </div>
              {whatsNewOpen && <WhatsNewAdmin open onClose={() => setWhatsNewOpen(false)} />}
              {aiAccessOpen && <AIAccessAdmin open onClose={() => setAIAccessOpen(false)} />}

              <hr />
              <Grid container spacing={2}>
                <Grid item xs={2} md={12}>
                  <label style={{ marginLeft: 15 }}>Objects Category</label>

                  <select
                    style={{ marginLeft: 20 }}
                    onChange={(e) => {
                      setSelectedCategory(e.target.value);
                    }}
                  >
                    {objectCateogryList.map((fruit,index) => (
                      <option key={index} value={fruit.id}>{fruit.text}</option>
                    ))}
                  </select>
                  <IconButton
                    variant="contained"
                    color="success"
                    onClick={openObjectAdminArea}
                    style={{ marginLeft: 5 }}
                    size="large"
                  >
                    <AddIcon />
                  </IconButton>

                  <input
                    style={{ marginLeft: 5 }}
                    accept=".svg"
                    onChange={OnChangeSelectedFiles}
                    type="file"
                    multiple
                  ></input>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={UploadObjectCategoryFiles}
                  >
                    Submit
                  </Button>
                </Grid>

                <Grid item xs={2} md={12}>
                  <label style={{ marginLeft: 15 }}>Props Category</label>
                  <select
                    style={{ marginLeft: 20 }}
                    onChange={(e) => {
                      setSelectedCategory(e.target.value);
                    }}
                  >
                    {propsCateogryList.map((fruit,index) => (
                      <option key={index} value={fruit.id}>{fruit.text}</option>
                    ))}
                  </select>
                  <IconButton
                    size="large"
                    color="success"
                    onClick={openPropsAdminArea}
                  >
                    <AddIcon />
                  </IconButton>

                  <input
                    accept=".json,.svg"
                    onChange={OnChangeSelectedFiles}
                    type="file"
                    multiple
                  ></input>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={UploadPropsCategoryFiles}
                  >
                    Submit
                  </Button>
                </Grid>

                {propsAdminArea && (
                  <Grid item xs={2} md={12}>
                    <hr />
                    <TextField
                      onChange={(e) => {
                        setCategoryName(e.target.value);
                      }}
                      InputProps={{
                        style: {
                          height: 30,
                          marginLeft: 10,
                          marginTop: 10,
                        },
                      }}
                      style={{ height: 10 }}
                      label={"Props Category"} //optional0
                    />
                    <Button
                      onClick={(e) => savePropsCateogry(e)}
                      style={{
                        height: 30,
                        marginLeft: 10,
                        marginTop: 10,
                      }}
                    >
                      Save
                    </Button>
                  </Grid>
                )}

                {objectAdminArea && (
                  <Grid item xs={2} md={12}>
                    <hr />
                    <TextField
                      onChange={(e) => {
                        setCategoryName(e.target.value);
                      }}
                      InputProps={{
                        style: {
                          height: 30,
                          marginLeft: 10,
                          marginTop: 10,
                        },
                      }}
                      style={{ height: 10 }}
                      label={"Objects Category"} //optional0
                    />
                    <Button
                      onClick={(e) => savePropsCateogry(e)}
                      style={{
                        height: 30,
                        marginLeft: 10,
                        marginTop: 10,
                      }}
                    >
                      Save
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default AdminProps;
